
(function() {

    // Function that will replace the active blog article from the blog roll if it's used on a blog article directly
    var hasRun = false;

    document.addEventListener('DOMContentLoaded', function() {
        if (hasRun) return;  // If the function has run before, exit early.

        // Helper function to clean up text: remove extra spaces
        function cleanText(text) {
            return text.replace(/\s+/g, ' ').trim();
        }

        // Get the text content of the headline with the class ".tl-hero-headline"
        var headlineText = cleanText(document.querySelector('.tl-hero-headline').textContent);

        // Search within the parent element ".tl-blog-roll" for each ".card__heading a"
        var links = document.querySelectorAll('.tl-blog-roll .card__heading a');


        var hasMatched = false; // Track if there's been a match

        // Loop through each link and compare its text content with the cleaned headline text
        links.forEach(function(link) {
            // Clean and update the link's text content
            var linkText = cleanText(link.textContent);
            link.textContent = linkText;  // Updating the text content in the DOM


            if (linkText === headlineText) {
                // Find the respective parent "li.blog__post" element of the matching linkText element and remove it
                var parentLi = link.closest('li.blog__post');
                if (parentLi) {
                    parentLi.remove();
                }
                hasMatched = true; // Set that there's been a match
            }
        });

        // If there's been a match, adjust the grid class
        if (hasMatched) {
            var parentUl = document.querySelector('.tl-blog-roll.blog__posts');
            if (parentUl) {
                var currentClass = Array.from(parentUl.classList).find(c => /grid--\d+-col-desktop/.test(c));
                if (currentClass) {
                    var currentNum = parseInt(currentClass.match(/grid--(\d+)-col-desktop/)[1]);
                    if (currentNum > 0) {
                        parentUl.classList.remove(currentClass);
                        parentUl.classList.add(`grid--${currentNum-1}-col-desktop`);
                    }
                }
            }
        }

        hasRun = true;  // Mark the function as having been run.
    });

})();